// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"h5-z"};